import { computed, watch, onBeforeMount, onMounted, onBeforeUnmount } from 'vue'
import { useAppStore, DeviceType } from '@/store/modules/app'
import useRouter from '@/hooks/useRouter'

const WIDTH = 992 // refer to Bootstrap's responsive design
const VIEWPORT_WIDTH = 480

const isMobileWidth = function (): boolean {
  const rect = document.body.getBoundingClientRect()
  return rect.width - 1 < WIDTH
}

const isMobileViewportCheck = function (): boolean {
  const rect = document.body.getBoundingClientRect()
  return rect.width - 1 < VIEWPORT_WIDTH
}

const resizeHandler = function () {
  const appStore = useAppStore()

  if (!document.hidden) {
    const wasMobile = appStore.device === DeviceType.Mobile
    const mobile = isMobileWidth()
    const mobileViewport = isMobileViewportCheck()
    appStore.ToggleDevice(mobile ? DeviceType.Mobile : DeviceType.Desktop)
    appStore.SetViewport(mobileViewport)
    if (mobile) {
      appStore.CloseSideBar(true)
    } else if (wasMobile) {
      appStore.OpenSideBar(true)
    }
  }
}

const useResize = () => {
  const appStore = useAppStore()

  const { route } = useRouter()
  const device = computed(() => {
    return appStore.device
  })

  const deviceClass = computed(() => {
    return appStore.device === DeviceType.Desktop ? 'desktop' : 'mobile'
  })

  const isDesktop = computed(() => {
    return appStore.device === DeviceType.Desktop
  })

  const isMobile = computed(() => {
    return appStore.device === DeviceType.Mobile
  })

  const isMobileViewport = computed(() => {
    return appStore.isMobileViewport
  })

  const sidebar = computed(() => {
    return appStore.sidebar
  })

  const colClass = computed(() => {
    if (window.matchMedia('(min-width: 1920px)').matches) {
      return 'xl'
    }

    if (window.matchMedia('(min-width: 1200px)').matches) {
      return 'lg'
    }

    if (window.matchMedia('(min-width: 992px)').matches) {
      return 'md'
    }

    if (window.matchMedia('(min-width: 768px)').matches) {
      return 'sm'
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      return 'xs'
    }

    return 'xl'
  })

  watch(
    () => route,
    () => {
      if (device.value === DeviceType.Mobile && sidebar.value.opened) {
        const appStore = useAppStore()

        appStore.CloseSideBar(false)
      }
    }
  )

  onBeforeMount(() => {
    window.addEventListener('resize', resizeHandler)
  })

  onMounted(() => {
    const mobile = isMobileWidth()
    const mobileViewport = isMobileViewportCheck()
    if (mobile) {
      const appStore = useAppStore()

      appStore.ToggleDevice(DeviceType.Mobile)
      appStore.SetViewport(mobileViewport)
      appStore.CloseSideBar(true)
    }
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', resizeHandler)
  })

  return {
    device,
    deviceClass,
    sidebar,
    isDesktop,
    isMobile,
    colClass,
    isMobileViewport
  }
}

export default useResize
